import React from 'react';

const Impressum = () => {
  return (
    <div className="pt-24 pb-20 bg-ms-light min-h-screen">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white p-12 lg:p-16 rounded-[3rem] shadow-2xl border border-ms-blue/5">
          <h1 className="text-4xl lg:text-5xl font-black text-ms-dark mb-12 uppercase tracking-tighter border-b-4 border-ms-blue pb-6">
            Impressum
          </h1>
          
          <div className="space-y-10 text-lg text-ms-dark/80 font-medium leading-relaxed">
            <section>
              <p>
                Murat Sario<br />
                Alte Schmiede 54<br />
                52525 Heinsberg
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-black text-ms-dark mb-4 uppercase tracking-tight">Kontakt</h2>
              <p>
                Telefon: <a href="tel:024521878831" className="text-ms-solar hover:text-ms-blue transition">024521878831</a><br />
                E-Mail: <a href="mailto:info@oscar-terrassen.de" className="text-ms-solar hover:text-ms-blue transition">info@oscar-terrassen.de</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-black text-ms-dark mb-4 uppercase tracking-tight break-words">
                Verbraucher&shy;streit&shy;beilegung / Universal&shy;schlichtungs&shy;stelle
              </h2>
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;